import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  show() {
    this._tip = document.createElement("div")
    this._tip.textContent = this.textValue
    this._tip.style.cssText = "position:fixed;z-index:9999;pointer-events:none;white-space:nowrap;background:#111827;color:#fff;font-size:0.75rem;line-height:1rem;padding:2px 8px;border-radius:4px;box-shadow:0 2px 6px rgba(0,0,0,.25);"
    document.body.appendChild(this._tip)
    this._position()
  }

  hide() {
    this._tip?.remove()
    this._tip = null
  }

  _position() {
    if (!this._tip) return
    const rect = this.element.getBoundingClientRect()
    const tip = this._tip.getBoundingClientRect()
    this._tip.style.left = `${rect.left + rect.width / 2 - tip.width / 2}px`
    this._tip.style.top = `${rect.top - tip.height - 6}px`
  }
}
